import {
    json,
    type LoaderFunctionArgs,
    type MetaFunction,
} from '@remix-run/node';
import { generateMeta } from '~/services/meta';
import AiToolMicroLanding from '~/components/AiToolMicroLanding';
import { prompts } from '~/services';
import { useLoaderData } from '@remix-run/react';

import type { SitemapFunction } from 'remix-sitemap';

export const sitemap: SitemapFunction = ({ config, request }) => {
    return prompts
        .filter((p) => p.id !== 'ocr-text')
        .map((prompt) => ({
            loc: `/tools/${prompt.type}/${prompt.id}`,
            lastmod: new Date().toISOString(),
            exclude: false,
        }));
};

export const meta: MetaFunction = ({ data }) => {
    return generateMeta({
        title: `${data.promptDefinition.seoTitle} ( No Login Required) - AI Perfect Assistant`,
        description: data.promptDefinition.seoDescription,
    });
};

export async function loader({ params }: LoaderFunctionArgs) {
    const promptId = params.promptId;
    const promptDefinition = prompts.find((p) => p.id === promptId);

    if (!promptDefinition || promptId === 'ocr-text') {
        throw new Response(`Can not find prompt with id ${promptId}`, {
            status: 404,
        });
    }

    const defaultPromptsIds = [
        'query-chat-gpt',
        'mail-improve-draft',
        'slides-outline',
    ];
    const relatedPromptsIds = prompts
        .filter((p) => p.type === promptDefinition.type)
        .filter((p) => p.id !== 'ocr-text')
        .map((p) => p.id);

    const uniquePrompts = new Set(
        [...relatedPromptsIds, ...defaultPromptsIds].filter(
            (pId) => pId !== promptDefinition.id,
        ),
    );
    const featuredPrompts = prompts
        .filter((p) => uniquePrompts.has(p.id))
        .slice(0, 2);

    return json({ promptDefinition, featuredPrompts });
}

export default function Index() {
    const { promptDefinition, featuredPrompts } = useLoaderData();
    return (
        <AiToolMicroLanding
            promptDefinition={promptDefinition}
            featuredPrompts={featuredPrompts}
        />
    );
}
